import {existingCustomerSelected, queryBearerToken} from "./UserAuthentication";
import {queryArticleOptionData} from "./ArticleData";
import {agencyServerArticleNumber, agencyServerProjectArticles, cmsArticles, shopArticles} from "../config/Config";
import {appInitialized} from "./AppInit";
import {putFormData} from "./FormData";
import {isMode} from "../selectors/Mode";
import {APP_MODE_AUTHENTICATED_ORDER, DOMAIN_TYPE_CUSTOM} from "../constants/General";
import {queryCustomerAccounts} from "./Accounts";
import {_customerNumber, _initialSoftware} from "../selectors/GetParam";
import {queryNewCart} from "./Cart";
import {PRODUCT_SELECTION} from "../constants/StepLabels";
import {queryCustomerResellers} from "./Resellers";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {toggleSelectionTriggered} from "./Util";
import {queryTopLevelDomains} from "./Domain";
import {selectCartProperty} from "./Properties";

export const initializeAppAuthenticatedOrder = (initParams) => (dispatch, getState) => {

    Promise.all([

        dispatch(queryBearerToken())

    ]).then(args => {

        if (args && args[0] && args[0].type === "CLIENTDATA_FAILURE") {
            alert("Diese Sitzung ist nicht mehr gültig!");
            return;
        }

        Promise.all([

            dispatch(queryNewCart()),
            dispatch(queryArticleOptionData(
                [
                    ...cmsArticles,
                    ...shopArticles,
                    ...agencyServerProjectArticles,
                    agencyServerArticleNumber
                ]
            )),
            dispatch(queryTopLevelDomains())

        ]).then(args => {

            Promise.all([
                ...getSoftwareLoaders().map(func => dispatch(func)),
            ]).then(args => {

                const postInitCalls = []

                postInitCalls.push(existingCustomerSelected())
                postInitCalls.push(queryCustomerAccounts(_customerNumber))
                postInitCalls.push(queryCustomerResellers(_customerNumber))

                Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {
                    dispatch(toggleSelectionTriggered('domainType', DOMAIN_TYPE_CUSTOM))
                    dispatch(selectCartProperty("software", _initialSoftware ? _initialSoftware : ""));
                    dispatch(appInitialized({...initParams, initialStep: PRODUCT_SELECTION}))
                    dispatch(putFormData())
                })
            });

        });
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.AuthenticatedOrder.js
 **/